<template>
    <div class="mx-auto">
        <b-card>
            <b-row class="d-flex justify-content-between">
                <b-col>
                    <CompBotaoExibirOcultarColuna
                            :fields="fields"
                            :showColunms="showColunms"
                            @toggleColuna="toggleColuna"/>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <b-form-select v-model="configTable.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm"
                                   class="mb-3 col-2" style="float:right"></b-form-select>
                    <b-button class="ml-2" variant="secondary" @click="limparFiltros"
                              style="float: right; margin-right: 10px; height: 32px; padding: 0 0.75rem;">
                        <i class="fas fa-broom"></i> Limpar Filtros
                    </b-button>
                </b-col>
            </b-row>

            <b-table
                    id="regrasPagamento"
                    :items="resultado"
                    :fields="fields"
                    striped
                    small
                    responsive
                    :busy="configTable.load"
                    show-empty
                    hover
                    bordered
                    class="mb-0"
                    head-variant="light">
                <div slot="table-busy" class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Carregando...</strong>
                </div>
                <template slot="empty">
                    <p class="my-auto">Nenhum registro encontrado.</p>
                </template>
                <template v-slot:head(selecionar)="{ item }">
                    <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
                </template>
                <template v-slot:cell(selecionar)="{ item }">
                    <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selecteds.includes(item)" @change="toggleCheck($event, item)" />
                </template>
                <template v-slot:head(1)="{ item }">
                    Número Requisição <i class="filter" :class="!isEmpty(filtros.numeroRequisicao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Número Requisição', 'mascara', '', '#########', $event)"></i>
                </template>
                <template v-slot:cell(1)="{ item }">
                    <p class="text-center">
                        <a class="link" @click="abrirModalExtrato(item)">
                            {{ item.numeroRequisicao }}
                        </a>
                    </p>
                </template>
                <template v-slot:head(2)="{ item }">
                    Tipo Requisição <i class="filter" :class="!isEmpty(filtros.tipoRequisicacao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo Requisição', 'checkbox', dados.tiposRequisicao, null, $event)"></i>
                </template>
                <template v-slot:cell(2)="{ item }">
                    {{ item.tabelaOrigem == 0 ? item.tipoRequisicao.nome + " - " + item.receita : item.receita }}
                </template>
                <template v-slot:head(3)="{ item }">
                    Processo <i class="filter" :class="!isEmpty(filtros.cnj) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Processo', 'mascara', '', 'cnj', $event)"></i>
                </template>
                <template v-slot:cell(3)="{ item }">
                    <p v-if="item.cnj.length == 1">
                        {{ item.cnj[0] }}
                    </p>
                    <p v-if="!item.abrirTodos && item.cnj.length > 1">
                        {{ item.cnj[0] }} <a class="link" @click="expandirOutros(item)">e outros</a>
                    </p>
                    <p v-for="cnj in item.cnj" v-if="item.abrirTodos && item.cnj.length > 1">
                        {{ cnj }}
                    </p>
                </template>
                <template v-slot:head(4)="{ item }">
                    CDA's
                </template>
                <template v-slot:cell(4)="{ item }">
                  <p class="text-center" v-if="item.cdas.length == 0">
                    -
                  </p>
                  <span v-for="(cda, index) in item.cdas">
                    <span v-if="index > 0">, </span>
                    <a class="link" @click="abrirModalExtratoCda(cda)">{{cda}}</a>
                  </span>
                </template>
                <template v-slot:head(5)="{ item }">
                    Devedor <i class="filter" :class="!isEmpty(filtros.contribuinte) || filtros.filtrarContribuinte == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Devedor', 'texto', '', null, $event)"></i>
                </template>
                <template v-slot:cell(5)="{ item }">
                    {{ item.devedor }}
                </template>
                <template v-slot:head(6)="{ item }">
                    Data Emissão <i class="filter" :class="!isEmpty(filtros.dataEmissao) || filtros.filtrarDataEmissao == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Emissão', 'data', '', null, $event)"></i>
                </template>
                <template v-slot:cell(6)="{ item }">
                    <p class="text-center">
                        {{ item.dataEmissao }}
                    </p>
                </template>
                <template v-slot:head(7)="{ item }">
                    Tipo Pagamento <i class="filter" :class="!isEmpty(filtros.tipoPagamento) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo Pagamento', 'checkbox', dados.tiposPagamento, null, $event)"></i>
                </template>
                <template v-slot:cell(7)="{ item }">
                    {{ item.tipoPagamento }}
                </template>
                <template v-slot:head(8)="{ item }">
                    Forma Pagamento <i class="filter" :class="!isEmpty(filtros.formaPagamento) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Forma Pagamento', 'checkbox', dados.formasPagamento, null, $event)"></i>
                </template>
                <template v-slot:cell(8)="{ item }">
                    {{ item.formaPagamento }}
                </template>
                <template v-slot:head(9)="{ item }">
                    Valor <i class="filter" :class="!isEmpty(filtros.valor) || filtros.filtrarValor == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor', 'numerico', '', null, $event)"></i>
                </template>
                <template v-slot:cell(9)="{ item }">
                    <p class="text-right" v-if="item.valor != null">
                        {{ item.valor | currency }}
                    </p>
                </template>
                <template v-slot:head(10)="{ item }">
                    Cadastrada por (serv/estag) <i class="filter" :class="!isEmpty(filtros.usuarioInclusao) || filtros.filtrarUsuarioInclusao == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Cadastrada por (serv/estag)', 'texto', '', null, $event)"></i>
                </template>
                <template v-slot:cell(10)="{ item }">
                    {{ item.usuarioInclusao }}
                </template>
                <template v-slot:head(11)="{ item }">
                    A ser aprovada por (Procurador) <i class="filter" :class="!isEmpty(filtros.procurador) || filtros.filtrarProcurador == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('A ser aprovada por (Procurador)', 'texto', '', null, $event)"></i>
                </template>
                <template v-slot:cell(11)="{ item }">
                    {{ item.nomeProcurador }}
                </template>
            </b-table>

            <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
                <b-col>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <div class="registros-encontrados">
                        <span>Requisições Encontradas:</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{configTable.perPage != 'Todos' ? configTable.rows : resultado.length}}</span>
                    </div>

                    <div class="registros-encontrados" style="margin-left: 15px">
                        <span>Requisições Selecionadas</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{selecteds.length}}</span>
                    </div>
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col md="3"></b-col>
                <b-col md="6">
                    <div class="d-flex justify-content-between align-items-center">
                        <div style="margin: auto">
                            <b-button class="ml-2" variant="primary" v-b-modal.modal-aprovar :disabled="selecteds.length < 1">
                                <i class="fas fa-check"></i> Aprovar
                            </b-button>
                            <b-button class="ml-2" variant="primary" v-b-modal.modal-cancelar-painel :disabled="selecteds.length < 1">
                                <i class="fa fa-times"></i> Cancelar
                            </b-button>
                            <b-button class="ml-2" variant="primary" @click="exportar">
                                <i class="fa fa-table"></i> Exportar CSV
                            </b-button>
                        </div>
                    </div>
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
            <b-modal
                    ref="modal-aprovar"
                    id="modal-aprovar"
                    size="xl"
                    :content-class="'shadow ' + getTheme"
                    title="Aprovar a Requisição"
                    header-bg-variant="success"
                    header-text-variant="white">
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <p style="font-weight: bold;">Deseja aprovar a(s) requisição(ões)?</p>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{ hide }">
                    <b-button variant="secondary" @click="hide('modal-aprovar')"> Voltar</b-button>
                    <b-button variant="primary" @click="aprovar"> Confirmar</b-button>
                </template>
            </b-modal>
            <b-modal
                    ref="modal-cancelar-painel"
                    id="modal-cancelar-painel"
                    size="xl"
                    :content-class="'shadow ' + getTheme"
                    title="Cancelar a Requisição"
                    header-bg-variant="success"
                    header-text-variant="white">
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <p style="font-weight: bold;">Deseja cancelar requisição?</p>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{ hide }">
                    <b-button variant="secondary" @click="hide('modal-cancelar-painel')"> Voltar</b-button>
                    <b-button variant="primary" @click="cancelar"> Confirmar</b-button>
                </template>
            </b-modal>
        </b-card>
    </div>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompBotaoExibirOcultarColuna from "../../shared/components/CompBotaoExibirOcultarColuna";

    export default {
    props: ['resultado', 'configTable', 'filtroComponente', 'filtros', 'loading', 'selecteds'],
    components: {CompBotaoExibirOcultarColuna},
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.$emit('consultar');
        },
        perPage() {
            this.configTable.currentPage = 1;
            this.$emit('consultar');
        }
    },
    data() {
        return {
            urlApi: null,
            token: null,
            showColunms: [],
            fields: [
                {
                    key: "selecionar",
                }
            ],
            dados: {
                formasPagamento: null,
                tiposPagamento: null,
                statusRequisicao: null,
                tiposRequisicao: [
                    {id: 1, nome: "Honorários de Ação Judicial"},
                    {id: 4, nome: "Honorários de EF - Base de Cálculo D.A. SEFA"},
                    {id: 3, nome: "Honorários de Protesto"},
                    {id: 0, nome: "Receita Diversa"},
                ]
            },
        }
    },
    computed: {
        getTheme () {
            return this.$store.getters.getTheme
        },
        currentPage() {
            return this.configTable.currentPage;
        },
        perPage() {
            return this.configTable.perPage;
        },
    },
    methods: {
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    el.checked = true;
                    if(!this.selecteds.includes(el)) {
                        this.selecteds.push(el);
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    el.checked = false;
                    if(this.selecteds.includes(el)) {
                        const index = this.selecteds.indexOf(el);
                        this.selecteds.splice(index, 1);
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                item.checked = checked;
                this.selecteds.push(item);
            } else {
                item.checked = checked;
                const index = this.selecteds.indexOf(item);
                this.selecteds.splice(index, 1);
                this.configTable.checkedAll = false;
            }

        },
        async obterColunasUsuario() {
            const funcionalidade = 'aprovacaoUsuario';

            this.configTable.load = true;
            axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                response.data.forEach((field, i) => {
                    if (field.ativo) {
                        this.showColunms.push(i + 1)
                    }
                    this.fields.push({
                        key: `${i + 1}`,
                        label: `${field.descricao}`,
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.configTable.load = false;
            })
        },

        toggleColuna(i) {
            let ativo;
            if (this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1);
                this.fields[i].thClass = 'd-none';
                this.fields[i].tdClass = 'd-none';
                ativo = false
            } else {
                this.showColunms.push(i);
                this.fields[i].thClass = '';
                this.fields[i].tdClass = '';
                ativo = true
            }

            this.atualizarConfiguracaoColunm(i, ativo)
        },

        async atualizarConfiguracaoColunm(i, ativo) {
            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo,
            };
            axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })
        },

        openFilter(campo, tipo, values, mask, event) {
            this.$emit('openFilterPopup', campo, tipo, values, mask, event);
        },

        exportar() {
            this.$emit('exportar', 'aprovacaoUsuario');
        },

        aprovar() {
            this.$refs['modal-aprovar'].hide();

            this.loading.showLoading();
            axios.post(`${this.urlApi}/v1/painelUsuario/aprovarRequisicao`, this.selecteds, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [{message: 'Operação realizada com sucesso!!!'}]});
                this.$emit('limparSelect');
                this.$emit('consultar');
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            });
        },

        cancelar() {
            this.$refs['modal-cancelar-painel'].hide();

            this.loading.showLoading();
            axios.post(`${this.urlApi}/v1/painelUsuario/reprovarRequisicao`, this.selecteds, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [{message: 'Operação realizada com sucesso!!!'}]});
                this.$emit('limparSelect');
                this.$emit('consultar');
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            });
        },
        async listarFormaPagamento() {
            axios.get(`${this.urlApi}/v1/receitasDiversas/listarFormaPagamento`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.formasPagamento = response.data
            })
        },
        async listarTiposPagamento() {
            axios.get(`${this.urlApi}/v1/regrasPagamento/listarTiposPagamento`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.tiposPagamento = response.data
            })
        },
        async listarStatusRequisicao() {
            axios.get(`${this.urlApi}/v1/pesquisas/listarStatusRequisicao`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.statusRequisicao = response.data
            })
        },
        abrirModalExtrato(item) {
            this.$emit('abrirExtrato', item);
        },

        limparFiltros() {
            this.$emit('limparFiltros');
        },
        abrirModalExtratoCda(numeroCda) {
          this.$emit('abrirExtratoCda', numeroCda);
        },
        expandirOutros(item) {
            item.abrirTodos = true;
        },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        this.obterColunasUsuario();
        this.listarFormaPagamento();
        this.listarTiposPagamento();
        this.listarStatusRequisicao();
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
